import {
  JSResource,
  type SimpleEntryPoint,
} from "@loop-payments/react-router-relay";
import type { TodosDone } from "./TodosDone";
import TodosQueryNode, {
  type TodosQuery$variables,
} from "./__generated__/TodosQuery.graphql";
import { parseTodoConnectionFilters } from "../model/TodoConnectionSerialization";
import { defaultDoneFilters } from "../components/TodoListDefaultFilters";

const entryPoint: SimpleEntryPoint<typeof TodosDone> = {
  root: JSResource("TodosDone", () =>
    import("./TodosDone").then((module) => module.TodosDone),
  ),
  getPreloadProps({ request }) {
    const url = new URL(request.url);
    const variables: TodosQuery$variables = parseTodoConnectionFilters(
      url.search,
      defaultDoneFilters,
    );

    return {
      queries: {
        query: {
          parameters: TodosQueryNode,
          variables,
          options: {
            fetchPolicy: "store-and-network",
          },
        },
      },
    };
  },
};

export default entryPoint;
